import { DefaultOptionType } from 'antd/lib/select'
import { SEPARATOR } from 'components/CIMSSelect/common/types'
import { EJReportOption, FromLabeledValuesValue } from './types'
import { EJReportType } from '@cims-online/shared'
import { toLabeledValues as to } from 'components/CIMSSelect/utils/labeledValues'

export function toLabeledValues(items: EJReportOption[]) {
  return to(items, {
    type: 'callback',
    callback: (item) => {
      let label, tooltip
      if (item.__typename === 'ConcreteTest') {
        label = item.fieldNumber
        tooltip = EJReportType.ConcreteTest.type
      } else if (item.__typename === 'ConcretePlacement') {
        label = item.placementId
        tooltip = EJReportType.ConcretePlacement.type
      } else if (item.__typename === 'Lot') {
        label = item.lotId
        tooltip = EJReportType.DensityLot.type
      } else if (item.__typename === 'DailyInspectionInspection') {
        label = item.inspectionId
        tooltip = EJReportType.DailyInspectionInspection.type
      } else if (item.__typename === 'DailyInspectionControlPoint') {
        label = item.controlPointId
        tooltip = EJReportType.DailyInspectionControlPoint.type
      }
      return {
        label: label ?? item.globalId,
        value: join(item),
        tooltip,
      }
    },
  })
}

export function split(
  value: DefaultOptionType['value']
): FromLabeledValuesValue {
  const [typename, itemId] =
    (value?.toString().split(SEPARATOR) as [
      EJReportOption['__typename'],
      string
    ]) ?? []
  const { id } = EJReportType.findOrFail(
    ({ classType }) => typename === classType
  )
  return { reportId: itemId, reportTypeId: id }
}

export const join = (item: EJReportOption) =>
  `${item.__typename}${SEPARATOR}${item.globalId}`
